import { useMutation } from "@blitzjs/rpc";
import { Typography, Alert, InputAdornment, Box } from "@mui/material"
import { PageContainer } from "src/app/core/components/PageContainer"
import EmailOutline from "mdi-material-ui/EmailOutline"
import AccountOutline from "mdi-material-ui/AccountOutline"
import PhoneOutline from "mdi-material-ui/PhoneOutline"
import CommentTextOutline from "mdi-material-ui/CommentTextOutline"
import { Nav } from "src/app/core/components/Nav"
import { Footer } from "src/app/core/components/Footer"
import { Form, FORM_ERROR } from "src/app/core/components/Form"
import { FormTextField } from "src/app/core/components/formFields/FormTextField"
import { SubmitButton } from "src/app/core/components/formFields/SubmitButton"
import contact from "./mutations/contact"
import { Contact } from "./validations"

export const ContactPage = () => {
  const [contactMutation, contactResult] = useMutation(contact)

  return (
    <Box display="flex" flexDirection="column" height="100%" width="100%">
      <div>
        <PageContainer>
          <Nav />
        </PageContainer>
      </div>
      <Box maxWidth={500} margin="0 auto" flex={"1 0 auto"}>
        <PageContainer>
          <Typography variant="h1" sx={{ mt: "2rem" }}>
            Contact
          </Typography>

          <Typography sx={{ mb: 4 }}>
            Wil je meer info of heb je een vraag? Contacteer ons via onderstaand formulier.
          </Typography>

          {contactResult.isSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Bedankt voor je bericht! Heb je na 48u nog geen antwoord? Check dan ook even je
              spam-folder.
            </Alert>
          )}

          <Form
            schema={Contact}
            initialValues={{ name: "", email: "", tel: "", message: "" }}
            onSubmit={async (values, reset) => {
              try {
                await contactMutation(values)
                reset()
              } catch (error: any) {
                return {
                  [FORM_ERROR]:
                    "Oeps, dat liep mis. Probeer later opnieuw of stuur ons een e-mail op\n" +
                    "            hello@hethuisvanvier.be",
                }
              }
            }}
          >
            <FormTextField
              name="name"
              label="Naam"
              placeholder="Naam"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountOutline sx={{ opacity: 0.5 }} />
                  </InputAdornment>
                ),
              }}
              required
            />
            <FormTextField
              name="email"
              label="E-mail"
              placeholder="E-mail"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutline sx={{ opacity: 0.5 }} />
                  </InputAdornment>
                ),
              }}
              required
            />

            <FormTextField
              name="tel"
              label="Telefoon"
              placeholder="Telefoon"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneOutline sx={{ opacity: 0.5 }} />
                  </InputAdornment>
                ),
              }}
            />

            <FormTextField
              name="message"
              label="Bericht"
              multiline
              required
              minRows={6}
              placeholder="Bericht"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CommentTextOutline sx={{ opacity: 0.5 }} />
                  </InputAdornment>
                ),
              }}
            />
            <SubmitButton sx={{ mt: 4, mb: 4 }}>Verzend</SubmitButton>
          </Form>
        </PageContainer>
      </Box>
      <Footer />
    </Box>
  )
}
